<template>
  <div>
    EXPERIENCE MANAGER
    <hr>
    <b-form-group :class="{'error-input' : $v.dataSetup.title.$error}">
      <label> Title </label>
      <j-input
        v-model="$v.dataSetup.title.$model"
        :max-length="255"
        placeholder="Input Title"/>
    </b-form-group>
    <b-form-group :class="{'error-input' : $v.dataSetup.form_ui.$error}">
      <label> Select Experience Manager </label>
      <j-single-select
        v-model="$v.dataSetup.form_ui.$model"
        :load-options="loadOptionsFormUI"
        :is-async="true"
        :cache-option="false"
        placeholder="Select experience manager"
        value-format="object"
        label="name"
      />
    </b-form-group>
    <b-form-group :class="{'error-input' : $v.dataSetup.default_view.$error}">
      <label> Select View </label>
      <j-single-select
        v-model="$v.dataSetup.default_view.$model"
        :options="listDefaultView"
        label="name"
        value-format="object"
        placeholder="Select view"
      />
    </b-form-group>

    <b-row class="mt-4">
      <b-col>
        <div class="float-to-right">
          <b-button
            class="btn gray m__r--5"
            @click="closeForm">
            Close
          </b-button>
          <b-button
            class="btn blue"
            @click="saveForm"
          >
            Save
          </b-button>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import jwtDecode from 'jwt-decode';
import { mapActions } from 'vuex';
import { required } from 'vuelidate/lib/validators';
import { ASYNC_SEARCH } from '@riophae/vue-treeselect';

export default {
  props: {
    dataMaster: {
      type: Object,
      default: () => {},
    },
    modeCreate: {
      type: Boolean,
      default: false,
    },
    modeEdit: {
      type: Boolean,
      default: false,
    },
    dataEdit: {
      type: Object,
      default: () => {},
    },
  },
  validations: {
    dataSetup: {
      title: { required },
      form_ui: { required },
      default_view: { required },
    },
  },
  data() {
    return {
      dataSetup: {
        title: '',
        form_ui: null,
        default_view: null,
      },
      listExperienceManager: [],
      listDefaultView: [],
      session: jwtDecode(JSON.parse(localStorage.getItem('Token')).value),
    };
  },
  computed: {
    generateData() {
      const data = {
        value_id: '0',
        widget_master_id: this.dataMaster.id,
        info: JSON.stringify({
          title: this.dataSetup.title,
          form_ui_id: this.dataSetup.form_ui.id,
          default_view: this.dataSetup.default_view.id,
        }),
        type: 3,
        company_id: this.dataMaster.company_id,
        position: this.dataMaster.position,
      };

      return data;
    },

    generateDataUpdate() {
      const data = {
        widget_master_id: this.dataMaster.id,
        info: JSON.stringify({
          title: this.dataSetup.title,
          form_ui_id: this.dataSetup.form_ui.id,
          default_view: this.dataSetup.default_view.id,
        }),
        type: 3,
        company_id: this.dataMaster.company_id,
        position: this.dataMaster.position,
        order: this.dataEdit.order,
      };

      return data;
    },
  },
  watch: {
    // eslint-disable-next-line
    'dataSetup.form_ui': function(data) {
      const filtered = Object.keys(data).filter(key => key === 'calendar_view');

      this.listDefaultView = filtered.map(el => ({
        id: el,
        name: el.replace(/_/g, ' ').replace(/^./, el[0].toUpperCase()),
      }));
    },
  },
  mounted() {
    if (this.modeEdit) {
      const info = JSON.parse(this.dataEdit.info);
      this.dataSetup.title = info.title;

      const dataFilter = {
        id: info.form_ui_id,
      };
      const params = {
        limit: 1,
        page: 1,
        filter: JSON.stringify(dataFilter),
      };
      this.findFormUi(params).then((response) => {
        if (response) {
          const dataFormUi = response[0];
          dataFormUi.label = dataFormUi.name;
          this.dataSetup.form_ui = dataFormUi;
          this.dataSetup.default_view = {
            id: info.default_view,
            name: info.default_view.replace(/_/g, ' ').replace(/^./, info.default_view[0].toUpperCase()),
          };
        }
      });
    }
  },
  methods: {
    ...mapActions('jStoreApplication', ['saveWidget', 'updateWidget']),
    ...mapActions('jStoreFormUi', ['findFormUi']),

    loadOptionsFormUI({ action, searchQuery, callback }) {
      if (action === ASYNC_SEARCH && searchQuery !== null) {
        if (searchQuery.length > 2) {
          const dataFilter = {
            name: searchQuery,
            company_id: this.session.user.company_id,
          };
          const reqData = {
            limit: 100,
            page: 1,
            filter: JSON.stringify(dataFilter),
          };
          this.$store.dispatch('jStoreFormUi/actionGetFormUiListAsync', { reqData, callback });
        } else {
          callback(null, false);
        }
      }
    },

    saveForm() {
      this.$v.dataSetup.$touch();
      if (!this.$v.dataSetup.$error) {
        if (!this.modeEdit) {
          const dataParam = this.generateData;
          this.saveWidget(dataParam);
        } else {
          const widgetId = this.dataEdit.id;
          const dataParam = this.generateDataUpdate;
          this.updateWidget({ widgetId, dataParam });
        }

        this.closeForm();
      }
    },

    closeForm() {
      this.$emit('close-field');
      this.dataSetup.title = '';
      this.dataSetup.form_ui = null;
      this.dataSetup.default_view = null;
      setTimeout(() => {
        this.$v.dataSetup.$reset();
      }, 1000);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/widget/widget-component/jExperienceManagerSetup.vue